import { LeagueDto } from '../api/sbapi/sbapi-api-model';
import { EventWithMarketsAndSelections } from '../sportsbook-types';

export type LeagueWithEvents = Pick<
	LeagueDto,
	'id' | 'name' | 'leagueOrder' | 'sportId' | 'sportName' | 'eventCount' | 'sportIcon'
> & {
	sportOrder: number;
	events: Array<EventWithMarketsAndSelections>;
};

export const reduceEventsToLeaguesWithEvents = (events: Array<EventWithMarketsAndSelections>) => {
	const leaguesMap = events.reduce<{ [key: string]: LeagueWithEvents }>((acc, event) => {
		if (!acc[event.leagueId]) {
			return {
				...acc,
				[event.leagueId]: {
					name: event.leagueName,
					id: event.leagueId,
					leagueOrder: event.leagueOrder,
					sportOrder: event.sportOrder,
					sportId: event.sportId,
					sportName: event.sportName,
					eventCount: 1,
					events: [event],
					sportIcon: event.metadata.sportIcon
				}
			};
		}

		acc[event.leagueId].eventCount += 1;
		acc[event.leagueId].events.push(event);

		return acc;
	}, {});

	return Object.values(leaguesMap);
};
